<template>
  <app-content class="h-panel">
    <div class="flex justify-between mx-16px pt-16px">
      <div></div>
      <div class="float-right flex items-center">
        <vxe-button @click="exportData" icon="fa fa-download" content="导出"/>
        <vxe-button @click="printData" icon="fa fa-print" content="打印"/>
        <vxe-button @click="loadList" icon="fa fa-print" content="刷新"/>
      </div>
    </div>
    <div class="h-panel-body">
      <!--  :tree-config="{transform: true, rowField: 'treeId', parentField: 'parentTreeId',expandAll: true,reserve: true}" -->
      <!--                  是否可以手动展开子节点                                                      默认展开所有节点 reserve是保持节点展开，但是不好用 -->
      <div class="text-center mb-16px font-bold text-20px">账龄分析表</div>
      <vxe-table 
                 show-footer
                 :footer-method="calcTotal"
                 :loading="loading" ref="xTable" :data="dataList" border >
        <vxe-column title="客户" field="name" align="left" tree-node width="12.5%"></vxe-column>
        <vxe-column title="1月内" field="is1" align="right" width="12.5%"></vxe-column>
        <vxe-column title="1-2个月" field="is2" align="right" width="12.5%"/>
        <vxe-column title="2-3个月" field="is3" align="right"  width="12.5%"/>
        <vxe-column title="3-6个月" field="is4" align="right"  width="12.5%"/>
        <vxe-column title="6-12个月" field="is5" align="right"  width="12.5%"/>
        <vxe-column title="12-24个月" field="is6" align="right"  width="12.5%"/>
        <vxe-column title="其他" field="other" align="right"  width="12.5%"/>
      </vxe-table>
    </div>
  </app-content>
</template>

<script>
import BooUtil from "@/views/accountbook/bookUtil";
import accountbook from "@/api/accountbook";
import {downloadBlob} from "download.js";
import {mapGetters, mapState} from "vuex";
import {clone} from "xe-utils";
import setting from "@/api/setting";

export default {
  name: "AgingReport",
  data() {
    return {
      tablePrint: {
        // 自定义打印的样式示例
        style: `
          /* 整个表格的基础样式 */
          .vxe-table {
            font-family: "Microsoft YaHei", 微软雅黑, "MicrosoftJhengHei", 华文细黑, STHeiti, MingLiu; // 设置表格整体字体
          }

          /* 表头单元格 */
          .vxe-table thead th {
            border: 1px solid #000;
            font-size: 14px;
            word-break: break-all;
            overflow-wrap: break-word;
          }

          /* 表体单元格（即数据行的所有单元格） */
          .vxe-body--column, 
          .vxe-table tbody td {
            border: 1px solid #000;
            font-size: 12px;
            word-break: break-all;
            overflow-wrap: break-word;
          }
          /* 表尾单元格样式 */
          .vxe-table tfoot td {
            border: 1px solid #000;
            font-size: 12px;
          }
        `,
        beforePrintMethod: ({ content }) => {
          const headerHtml = `<h3>账龄分析表</h3>
            <div style="display:flex;justify-content: space-between;height:22px;line-height:22px">
                <span>编制单位：${this.currentAccountSets.companyName}</span>
                <span> 单位：元 </span>
            </div>
          `;
          const footerHtml = ``;
          return `${headerHtml}${content}${footerHtml}`;
        },
      },
      isAll: false,
      dataList:[],
      checkDataLists: [],
      params: {
        start: null,
        accountStandard:null,
      },
    }
  },
  computed: {
    ...mapState(['currentAccountSets']),
    ...mapGetters(['checkoutSelect', 'localCurrency']),
  },
  watch: {

  },
  methods: {
    printData() {
      // 获取VXE-Table实例
      const xTable = this.$refs.xTable;
      // 调用打印方法，并传入打印配置
      xTable.print({
        ...this.tablePrint,
      });
    },
    exportData() {
      const utils = new BooUtil(this.$refs.xTable, '\n')
      accountbook.download({header: utils.header, dataList: utils.dataList}).then((data) => {
        downloadBlob(`账龄分析表.xls`, data)
      })
    },
    calcTotal({columns, data}) {
      let formatter = new Intl.NumberFormat('en-US', {  
        minimumFractionDigits: 2,  
        maximumFractionDigits: 2,  
        style: 'decimal', // 或者使用'currency'并设置currency属性为'USD'等，但注意这会添加货币符号  
      });
      const row = [];
      columns.forEach(col => {
        if ('is1' === col.property) {  
          let allAmountMonth = 0;
          this.dataList.forEach(item => {
            let num = Number(item.is1.replace(/,/g, ''));
            allAmountMonth += Number(num);
          })
          row.push(col.property === "is1" ? formatter.format(allAmountMonth) != 0 ? formatter.format(allAmountMonth) : "" : "")
        }else if('is2' === col.property){
          let allAmountMonth = 0;
          this.dataList.forEach(item => {
            let num = Number(item.is2.replace(/,/g, ''));
            allAmountMonth += Number(num);
          })
          row.push(col.property === "is2" ? formatter.format(allAmountMonth) != 0 ? formatter.format(allAmountMonth) : ""  : "")
        }else if('is3' === col.property){
          let allAmountMonth = 0;
          this.dataList.forEach(item => {
            let num = Number(item.is3.replace(/,/g, ''));
            allAmountMonth += Number(num);
          })
          row.push(col.property === "is3" ? formatter.format(allAmountMonth) != 0 ? formatter.format(allAmountMonth) : ""  : "")
        }else if('is4' === col.property){
          let allAmountMonth = 0;
          this.dataList.forEach(item => {
            let num = Number(item.is4.replace(/,/g, ''));
            allAmountMonth += Number(num);
          })
          row.push(col.property === "is4" ? formatter.format(allAmountMonth) != 0 ? formatter.format(allAmountMonth) : ""  : "")
        }else if('is5' === col.property){
          let allAmountMonth = 0;
          this.dataList.forEach(item => {
            let num = Number(item.is5.replace(/,/g, ''));
            allAmountMonth += Number(num);
          })
          row.push(col.property === "is5" ? formatter.format(allAmountMonth) != 0 ? formatter.format(allAmountMonth) : ""  : "")
        }else if('is6' === col.property){
          let allAmountMonth = 0;
          this.dataList.forEach(item => {
            let num = Number(item.is6.replace(/,/g, ''));
            allAmountMonth += Number(num);
          })
          row.push(col.property === "is6" ? formatter.format(allAmountMonth) != 0 ? formatter.format(allAmountMonth) : ""  : "")
        }else if('other' === col.property){
          let allAmountMonth = 0;
          this.dataList.forEach(item => {
            let num = Number(item.other.replace(/,/g, ''));
            allAmountMonth += Number(num);
          })
          row.push(col.property === "other" ? formatter.format(allAmountMonth) != 0 ? formatter.format(allAmountMonth) : ""  : "")
        }else {
          row.push(col.property === "name" ? '合计' : "")
        }
      })
      return [row];
    },
    loadList() {
      this.loading = true;
      this.$api.accountbook.loadAgingReport({
        accountStandard:this.currentAccountSets.accountStandard
      }).then(({data}) => {
         this.loading = false;
          let formatter = new Intl.NumberFormat('en-US', {  
            minimumFractionDigits: 2,  
            maximumFractionDigits: 2,  
            style: 'decimal', // 或者使用'currency'并设置currency属性为'USD'等，但注意这会添加货币符号  
          });
          console.log(data);
          let dataListTepm = [];
          data.forEach(element => {
            let aggregated = {};
            aggregated.others = element.others;
            aggregated.name = element.name; // 直接将 name 属性添加到 aggregated 对象
            aggregated.other = element.other;
            element.time.forEach(obj => {
                Object.keys(obj).forEach(key => {
                    if (!aggregated[key]) {
                        aggregated[key] = 0;
                    }
                    aggregated[key] += obj[key];
                });
            });
            // 添加到 dataList
            dataListTepm.push(aggregated);
          });

          // 打印处理后的数据列表
          console.log(dataListTepm);

          //按月份组装数据
          let dataList = [];
          dataListTepm.forEach(element => {
            let obj = {
              name:'',
              is1:0,
              is2:0,
              is3:0,
              is4:0,
              is5:0,
              is6:0
            };
            const keys = Object.keys(element);
            for (const key of keys) {
              if (key == 'name') {
                  obj.name = element[key];
              }else if(key == "other"){
                obj.other = element[key];
              }else if(key == "others"){
                obj.others = element[key];
              }else if(key <= 1){
                  obj.is1 += element[key];
              }else if(key > 1 && key <= 2){
                  obj.is2 += element[key];
              }else if(key > 2 && key <= 3){
                  obj.is3 += element[key];
              }else if(key > 3 && key <= 6){
                  obj.is4 += element[key];
              }else if(key > 6 && key <= 12){
                  obj.is5 += element[key];
              }else if(key >= 12 && key <= 24){
                  obj.is6 += element[key];
              }
            }
            dataList.push(obj);
          });
          dataList.forEach(element => {
            const keys = Object.keys(element);
            for (const key of keys) {
              if (key == 'name') {
                  continue;
              }else{
                if(element[key] > 0){
                  element[key] = element[key].toFixed(2);
                }else{
                  element[key] = '';
                }
              }
            }
          });
          console.log(dataList);
          dataList.forEach(element => {
              if (Number(element.others) > 0) {
                  let remainingOthers = Number(element.others);
                  // 遍历 is1 到 is6
                  for (let i = 6; i >= 1; i--) {
                      const key = `is${i}`;
                      if (element[key]) {
                          let value = Number(element[key]);

                          if (value > 0 && remainingOthers > 0) {
                              if (value >= remainingOthers) {
                                  // 当前值足够减去剩余的 others
                                  element[key] = (value - remainingOthers).toFixed(2);
                                  remainingOthers = 0;
                              } else {
                                  // 当前值不足以减去剩余的 others
                                  remainingOthers -= value;
                                  element[key] = '0.00';
                              }
                          }
                      }

                      // 如果 remainingOthers 已经为 0, 则可以跳出循环
                      if (remainingOthers === 0) break;
                  }
              }
          });
          dataList.forEach(element => {
            if (Number(element.is1) > 0) {
              element.is1 = formatter.format(element.is1);
            }else{
              element.is1 = '';
            }
            if (Number(element.is2) > 0) {
              element.is2 = formatter.format(element.is2);
            }else{
              element.is2 = '';
            }
            if (Number(element.is3) > 0) {
              element.is3 = formatter.format(element.is3);
            }else{
              element.is3 = '';
            }
            if (Number(element.is4) > 0) {
              element.is4 = formatter.format(element.is4);
            }else{
              element.is4 = '';
            }
            if (Number(element.is5) > 0) {
              element.is5 = formatter.format(element.is5);
            }else{
              element.is5 = '';
            }
            if (Number(element.is6) > 0) {
              element.is6 = formatter.format(element.is6);
            }else{
              element.is6 = '';
            }
          });
          this.dataList = dataList;
        }).finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.loadList();
  }
}
</script>

<style scoped lang="less">

</style>


<script setup>
import manba from 'manba'
</script>
